(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_bat"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zs-bat')) {
    /**
     * A bat that actually flies: it picks a spot in its flight area, steers
     * there with a bat's fluttery, slightly erratic line, banks into turns and
     * beats its wings (harder when climbing, gliding when it dives). The drawn
     * bat's wings rotate about their shoulders; a custom image just squashes.
     */
    class ZsBat extends HTMLElement {
      connectedCallback() {
        this.stage = this.closest('.floating-stickers') || this.parentElement;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 749px)');
        if (!this.stage || this.reduce.matches || this.closest('.floating-stickers--static-editor')) return;

        this.wingL = this.querySelector('[data-wing="left"]');
        this.wingR = this.querySelector('[data-wing="right"]');
        this.flap = this.querySelector('.zs-bat__flap');
        this.seed = Number(this.dataset.offset || 0) * 7.3 + Math.random() * 100;
        this.time = 0;
        this.phase = this.seed;
        this.bank = 0;
        this.running = false;
        this.visible = false;

        this.setAttribute('data-flying', '');
        this.measure();
        this.pos = { ...this.anchor };
        const a = Math.random() * Math.PI * 2;
        this.vel = { x: Math.cos(a) * this.speed * 0.5, y: Math.sin(a) * this.speed * 0.5 };
        this.pickTarget();

        this.tick = (t) => this.step(t);
        this.resize = new ResizeObserver(() => {
          this.measure();
          this.sync();
        });
        this.resize.observe(this.stage);
        this.io = new IntersectionObserver(([entry]) => {
          this.visible = !!entry?.isIntersecting;
          this.sync();
        });
        this.io.observe(this.stage);
        this.onVisibility = () => this.sync();
        document.addEventListener('visibilitychange', this.onVisibility);
      }

      disconnectedCallback() {
        this.running = false;
        this.resize?.disconnect();
        this.io?.disconnect();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      sync() {
        const go = this.visible && !document.hidden && this.offsetWidth > 0;
        if (go && !this.running) {
          this.running = true;
          this.last = performance.now();
          requestAnimationFrame(this.tick);
        } else if (!go) {
          this.running = false;
        }
      }

      /** Flight area and speed, from the section size and the block settings. */
      measure() {
        const W = this.stage.clientWidth;
        const H = this.stage.clientHeight;
        const d = this.dataset;
        const small = this.mobile.matches;
        const x = Number((small && d.xMobile) || d.x || 50) / 100;
        const y = Number((small && d.yMobile) || d.y || 28) / 100;
        this.size = { w: this.offsetWidth, h: this.offsetWidth / 2 };
        this.anchor = { x: W * x, y: H * y };

        const pad = this.size.w * 0.6;
        if (d.roamSection === 'true') {
          this.box = { x0: pad, x1: W - pad, y0: Math.max(pad * 0.6, H * 0.05), y1: H * 0.68 };
        } else {
          const rx = Number(d.roamX || 160);
          const ry = Number(d.roamY || 90);
          this.box = {
            x0: Math.max(pad, this.anchor.x - rx),
            x1: Math.min(W - pad, this.anchor.x + rx),
            y0: Math.max(pad * 0.6, this.anchor.y - ry),
            y1: Math.min(H - pad, this.anchor.y + ry),
          };
        }
        const span = Math.max(this.box.x1 - this.box.x0, 200);
        // "Flight loop" (s) reads as pace: about how long one crossing takes.
        this.speed = Math.min(380, Math.max(110, span / (Number(d.pace || 20) * 0.3)));
        this.beat = Math.max(0.12, Number(d.beat || 500) / 2000);
      }

      pickTarget() {
        const b = this.box;
        const far = Math.hypot(b.x1 - b.x0, b.y1 - b.y0) * 0.3;
        let best = null;
        for (let i = 0; i < 8; i++) {
          const p = { x: b.x0 + Math.random() * (b.x1 - b.x0), y: b.y0 + Math.random() * (b.y1 - b.y0) };
          best = p;
          if (Math.hypot(p.x - this.pos.x, p.y - this.pos.y) > far) break;
        }
        this.target = best;
        this.until = this.time + 2.5 + Math.random() * 3;
      }

      step(now) {
        if (!this.running) return;
        const dt = Math.min(0.05, (now - this.last) / 1000);
        this.last = now;
        this.time += dt;

        const dx = this.target.x - this.pos.x;
        const dy = this.target.y - this.pos.y;
        const dist = Math.hypot(dx, dy) || 1;
        if (dist < 50 || this.time > this.until) this.pickTarget();

        // Steer toward the target with a lateral flutter, the way bats jink.
        const ux = dx / dist;
        const uy = dy / dist;
        const t = this.time + this.seed;
        const cruise = this.speed * (0.85 + 0.25 * Math.sin(t * 0.9));
        const wobble = 0.35 * Math.sin(t * 5.3) + 0.2 * Math.sin(t * 8.1 + 1.7);
        const wantX = (ux - uy * wobble) * cruise;
        const wantY = (uy + ux * wobble) * cruise;
        const k = Math.min(1, dt * 2.6);
        this.vel.x += (wantX - this.vel.x) * k;
        this.vel.y += (wantY - this.vel.y) * k;
        this.pos.x += this.vel.x * dt;
        this.pos.y += this.vel.y * dt;

        const vx = Math.max(-1, Math.min(1, this.vel.x / this.speed));
        const climb = Math.max(-1, Math.min(1, -this.vel.y / this.speed));
        this.bank += (vx * 16 - climb * 4 - this.bank) * Math.min(1, dt * 6);
        const depth = 1 + 0.1 * Math.sin(t * 0.37);

        // Wing-beat: faster and deeper climbing, shallow glide when diving.
        const rate = (1 / this.beat) * (1 + 0.35 * Math.max(0, climb));
        this.phase += dt * rate * Math.PI * 2;
        const amp = 30 + 8 * Math.max(0, climb) - 16 * Math.max(0, -climb - 0.3);
        const s = Math.sin(this.phase);
        const angle = amp * s - 4;
        const fore = 1 - 0.14 * Math.abs(s);
        const bob = -3 * Math.cos(this.phase);

        this.style.transform =
          `translate3d(${this.pos.x - this.size.w / 2}px, ${this.pos.y - this.size.h / 2 + bob}px, 0) ` +
          `rotate(${this.bank.toFixed(2)}deg) scale(${depth.toFixed(3)})`;
        if (this.wingL && this.wingR) {
          this.wingL.setAttribute('transform', `translate(110 56) rotate(${(-angle).toFixed(2)}) scale(${fore.toFixed(3)} 1) translate(-110 -56)`);
          this.wingR.setAttribute('transform', `translate(130 56) rotate(${angle.toFixed(2)}) scale(${fore.toFixed(3)} 1) translate(-130 -56)`);
        } else if (this.flap) {
          this.flap.style.scale = `1 ${(1 - 0.25 * Math.abs(s)).toFixed(3)}`;
        }

        requestAnimationFrame(this.tick);
      }
    }

    customElements.define('zs-bat', ZsBat);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_spider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zs-spider')) {
    class ZsSpider extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('.zs-spider__body');
        if (!this.body) return;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.busy = false;
        this.onEnter = () => this.scurry();
        this.onEnd = (event) => {
          if (event.animationName === 'zs-spider-climb') {
            this.classList.remove('is-scurrying');
            this.busy = false;
          }
        };
        this.body.addEventListener('pointerenter', this.onEnter);
        this.addEventListener('animationend', this.onEnd);
      }

      scurry() {
        if (this.busy || this.reduce.matches) return;
        this.busy = true;
        this.classList.add('is-scurrying');
      }

      disconnectedCallback() {
        this.body?.removeEventListener('pointerenter', this.onEnter);
        this.removeEventListener('animationend', this.onEnd);
      }
    }

    customElements.define('zs-spider', ZsSpider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rotating-arc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rotating-arc-component')) {
    class RotatingArcComponent extends HTMLElement {
      connectedCallback() {
        this.disc = this.querySelector('.rotating-arc__disc');
        this.viewport = this.querySelector('.rotating-arc__viewport');
        if (!this.disc) return;
        this.originals = Array.from(this.disc.children);
        this.handleResize = () => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => {
            // Mobile browsers fire resize when the URL bar collapses/expands
            // while scrolling — a height-only change. Relaying out would
            // restart the spin animation, and the arc geometry only depends
            // on width, so skip those.
            if (window.innerWidth === this.layoutWidth) return;
            this.layout();
          }, 150);
        };
        window.addEventListener('resize', this.handleResize);
        requestAnimationFrame(() => this.layout());
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        clearTimeout(this.resizeTimer);
      }

      layout() {
        this.layoutWidth = window.innerWidth;

        // Pick the radius for the current viewport; layout() reruns on resize,
        // so crossing the breakpoint re-resolves it. The CSS transforms read
        // --arc-radius, so the inline value set here must stay in sync with
        // the radius used for the angle math below.
        const mobileRadius = parseFloat(this.dataset.radiusMobile);
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const chosenRadius = isMobile && mobileRadius ? mobileRadius : parseFloat(this.dataset.radius);
        const radius = Math.max(chosenRadius || 1600, 100);
        this.style.setProperty('--arc-radius', radius + 'px');
        const gap = parseFloat(this.dataset.gap) || 0;
        const speed = Math.max(parseFloat(this.dataset.speed) || 60, 1);
        const MAX_ITEMS = 200;

        this.disc.querySelectorAll('[data-arc-clone]').forEach((el) => el.remove());
        const items = this.originals.filter((el) => el.isConnected);
        if (!items.length) return;

        // Measure in the flat flex-row state
        this.disc.classList.remove('rotating-arc__disc--positioned');
        items.forEach((el) => el.style.removeProperty('width'));
        const sizes = items.map((el) => ({
          w: Math.max(el.offsetWidth, 1),
          h: Math.max(el.offsetHeight, 1),
        }));
        const maxHeight = Math.max(...sizes.map((s) => s.h));

        // Lock the measured width so percentage-based image widths don't
        // re-resolve against the full-width disc once positioned
        items.forEach((el, i) => {
          el.style.width = sizes[i].w + 'px';
        });

        // Angle between consecutive item centers so the straight-line gap holds
        const steps = items.map((_, i) => {
          const next = sizes[(i + 1) % sizes.length];
          return ((sizes[i].w + next.w) / 2 + gap) / radius;
        });
        const setAngle = steps.reduce((sum, a) => sum + a, 0);

        // Repeat the set until the circle is filled, then scale spacing so the
        // loop closes exactly (seamless rotation with no seam gap)
        const maxSets = Math.max(1, Math.floor(MAX_ITEMS / items.length));
        const sets = Math.min(Math.max(1, Math.ceil((Math.PI * 2) / setAngle)), maxSets);
        const scale = (Math.PI * 2) / (setAngle * sets);

        const all = [...items];
        for (let s = 1; s < sets; s++) {
          for (const el of items) {
            const clone = el.cloneNode(true);
            clone.setAttribute('data-arc-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            for (const node of [clone, ...clone.querySelectorAll('[data-block-id], [id]')]) {
              node.removeAttribute('data-block-id');
              node.removeAttribute('id');
            }
            this.disc.appendChild(clone);
            all.push(clone);
          }
        }

        let angle = 0;
        all.forEach((el, i) => {
          el.style.setProperty('--arc-angle', angle.toFixed(5) + 'rad');
          angle += steps[i % steps.length] * scale;
        });

        // Viewport height matches the crest item; the arc's drop toward the
        // edges intentionally runs past the bottom and gets clipped
        this.style.setProperty('--arc-max-item-height', Math.ceil(maxHeight) + 'px');
        this.style.setProperty('--arc-height', Math.ceil(maxHeight) + 'px');
        this.style.setProperty('--arc-duration', ((Math.PI * 2 * radius) / speed).toFixed(1) + 's');
        this.disc.classList.add('rotating-arc__disc--positioned');
      }
    }
    customElements.define('rotating-arc-component', RotatingArcComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["scroll-highlight-text"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scroll-highlight-text')) {
    class ScrollHighlightText extends HTMLElement {
      connectedCallback() {
        this.#refresh();
        // A separate mobile text copy can swap in at the breakpoint, so
        // re-resolve which copy drives the animation when it flips
        this.#mobileQuery.addEventListener('change', this.#onBreakpointChange);
        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener('shopify:section:load', this.#onSectionLoad);
        }
      }

      disconnectedCallback() {
        if (this.#onLoad) window.removeEventListener('load', this.#onLoad);
        document.removeEventListener('shopify:section:load', this.#onSectionLoad);
        this.#squeezeQuery.removeEventListener('change', this.#onLayoutChange);
        this.#mobileQuery.removeEventListener('change', this.#onBreakpointChange);
        if (this.#trigger) this.#trigger.kill();
      }

      #mobileQuery = window.matchMedia('(max-width: 749px)');
      #onBreakpointChange = () => this.#refresh();

      #onLoad = null;
      #trigger = null;
      #units = [];
      #litCount = -1;
      #stickers = new Map();
      #usedStickers = new Set();
      #tokenSplitter = /(\[[a-zA-Z0-9_-]+\])/;
      // Editor edits morph the section DOM in place without reconnecting
      // this element, so re-run on section load
      #onSectionLoad = (event) => {
        if (event.target instanceof HTMLElement && event.target.contains(this)) this.#refresh();
      };

      #refresh() {
        this.#prepare();

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.#light(1);
          return;
        }

        if (window.gsap && window.ScrollTrigger) {
          this.#init();
        } else if (document.readyState === 'complete') {
          // GSAP disabled in theme settings — show the text fully lit
          this.#light(1);
        } else if (!this.#onLoad) {
          this.#onLoad = () => (window.gsap && window.ScrollTrigger ? this.#init() : this.#light(1));
          window.addEventListener('load', this.#onLoad, { once: true });
        }
      }
      // On desktop the theme scrolls .page-wrapper, not the window (see scroll-container.js)
      #squeezeQuery = window.matchMedia('(min-width: 990px)');
      #onLayoutChange = () => this.#init();

      #scroller() {
        if (this.#squeezeQuery.matches) {
          return document.querySelector('.page-wrapper') ?? window;
        }
        return window;
      }

      #prepare() {
        const contents = Array.from(this.querySelectorAll('.scroll-highlight-text__content'));
        if (!contents.length) return;

        // Detect the split by its spans, not a flag: editor edits can morph
        // the DOM back to its server-rendered (unsplit) state in place
        const unsplit = contents.filter((el) => !el.querySelector('.sht-unit'));
        if (unsplit.length) {
          this.#stickers = new Map(
            Array.from(this.querySelectorAll('.scroll-highlight-text__stickers [data-sticker-key]')).map(
              (el) => [el.dataset.stickerKey, el]
            )
          );
          this.#usedStickers = new Set();

          // Keys match bracketed ([gummy]) or bare (gummy), longest key first
          const keys = Array.from(this.#stickers.keys())
            .filter(Boolean)
            .sort((a, b) => b.length - a.length)
            .map((key) => key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
          this.#tokenSplitter = keys.length
            ? new RegExp(`(\\[[a-zA-Z0-9_-]+\\]|\\b(?:${keys.join('|')})\\b)`, 'i')
            : /(\[[a-zA-Z0-9_-]+\])/;

          unsplit.forEach((el) => this.#splitWords(el, this.dataset.split === 'characters'));
        }

        // With a separate mobile copy, only the breakpoint-visible one drives
        // the animation; the hidden copy's units would skew the progress count
        const visible = contents.find((el) => getComputedStyle(el).display !== 'none') ?? contents[0];
        this.#units = Array.from(visible.querySelectorAll('.sht-unit'));
        this.#litCount = -1;
      }

      #init() {
        if (!this.#units.length) return;

        gsap.registerPlugin(ScrollTrigger);

        if (this.#trigger) this.#trigger.kill();
        this.#litCount = -1;

        const start = parseInt(this.dataset.start, 10) || 85;
        const end = parseInt(this.dataset.end, 10) || 45;

        this.#trigger = ScrollTrigger.create({
          trigger: this,
          scroller: this.#scroller(),
          start: `top ${start}%`,
          end: `bottom ${end}%`,
          onUpdate: (self) => this.#light(self.progress),
          onRefresh: (self) => this.#light(self.progress),
        });

        this.#squeezeQuery.removeEventListener('change', this.#onLayoutChange);
        this.#squeezeQuery.addEventListener('change', this.#onLayoutChange);
      }

      // Moves the sticker element into the text; clones it if the key is reused
      #takeSticker(key) {
        const source = this.#stickers.get(key);
        if (!source) return null;
        const sticker = this.#usedStickers.has(key) ? source.cloneNode(true) : source;
        this.#usedStickers.add(key);
        sticker.classList.add('sht-unit');
        return sticker;
      }

      #light(progress) {
        // Re-split if a DOM morph replaced the spans since the last update
        if (this.#units.length && !this.#units[0].isConnected) this.#prepare();
        const count = Math.round(progress * this.#units.length);
        if (count === this.#litCount) return;
        this.#units.forEach((unit, i) => unit.classList.toggle('is-lit', i < count));
        this.#litCount = count;
      }

      // Wraps each word in a span (and each character in a nested span when
      // perCharacter), preserving inline elements like <strong> and <a>
      #splitWords(node, perCharacter) {
        Array.from(node.childNodes).forEach((child) => {
          if (child.nodeType === Node.ELEMENT_NODE) {
            this.#splitWords(child, perCharacter);
            return;
          }
          if (child.nodeType !== Node.TEXT_NODE || !child.textContent.trim()) return;

          const fragment = document.createDocumentFragment();
          // [key] placeholders are replaced by their sticker; a bare key keeps
          // the word and renders its sticker just before it
          child.textContent.split(this.#tokenSplitter).forEach((segment) => {
            if (!segment) return;

            const bracket = segment.match(/^\[([a-zA-Z0-9_-]+)\]$/);
            if (bracket) {
              const sticker = this.#takeSticker(bracket[1].toLowerCase());
              if (sticker) {
                fragment.appendChild(sticker);
                return;
              }
            } else {
              const sticker = this.#takeSticker(segment.toLowerCase());
              if (sticker) fragment.appendChild(sticker);
            }

            segment.split(/(\s+)/).forEach((part) => {
              if (!part) return;
              if (!part.trim()) {
                fragment.appendChild(document.createTextNode(part));
                return;
              }
              const word = document.createElement('span');
              word.className = 'sht-word';
              if (perCharacter) {
                for (const char of part) {
                  const unit = document.createElement('span');
                  unit.className = 'sht-unit';
                  unit.textContent = char;
                  word.appendChild(unit);
                }
              } else {
                word.classList.add('sht-unit');
                word.textContent = part;
              }
              fragment.appendChild(word);
            });
          });
          child.replaceWith(fragment);
        });
      }
    }

    customElements.define('scroll-highlight-text', ScrollHighlightText);
  }
  } catch(e) { console.error(e); }
})();

})();
